import { createContext, useContext, useMemo, useState } from 'react'

// Carries the applicant's details + auth tokens across the routed
// Details → Verify → Complete pages, since each is its own code-split route
// rather than a step inside one component.
const RegistrationContext = createContext(null)

const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  dialCode: '',
  phone: '',
  stage: '',
  sector: '',
  resumeFile: null,
  pitchDeckFile: null,
  resumeCandidateId: null,
  otpSessionId: '',
  candidateId: null,
  idToken: null,
  refreshToken: null,
  authUserRecord: null,
  campaignId: null,
}

export function RegistrationProvider({ children }) {
  const [state, setState] = useState(initialState)

  const update = (patch) => setState((prev) => ({ ...prev, ...patch }))
  const reset = () => setState(initialState)

  const value = useMemo(() => ({ ...state, update, reset }), [state])

  return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>
}

export function useRegistration() {
  const ctx = useContext(RegistrationContext)
  if (!ctx) throw new Error('useRegistration must be used within a RegistrationProvider')
  return ctx
}
